import { PointTuple } from "leaflet";

export class MarkerIcon {
    public iconUrl: string;
    public iconSize: PointTuple;
    public shadowUrl: string;
    public iconAnchor: PointTuple;

    constructor(iUrl: string, iSize: PointTuple, sUrl: string, iAnchor: PointTuple) {
        this.iconUrl = iUrl;
        this.iconSize = iSize;
        this.shadowUrl = sUrl;
        this.iconAnchor = iAnchor;
    }
}